import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { UserService } from './shared/services/user.service';
import { CallbackComponent } from './shared/components/callback/callback.component';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        canActivate: [UserService],
        children: [
            {
                path: 'restricted-product',
                loadChildren: () =>
                    import('./core/restricted-product/restricted-product.module').then(
                        (m) => m.RestrictedProductModule
                    ),
            },
            {
                path: 'user-permissions',
                loadChildren: () =>
                    import('./core/user-permissions/user-permissions.module').then((m) => m.UserPermissionsModule),
            },
        ],
    },
    { path: 'callback', component: CallbackComponent },
    { path: 'logout', redirectTo: '' },
    { path: '**', redirectTo: 'restricted-product' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { enableTracing: false })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
